import dayjs from 'dayjs'
import type { Form as EditForm } from '~/components/me/edit/edit-form.vue'

// PATCH /me に投げる body の正規化。Vue form と wire spec の差分を吸収する純関数:
// - lastName / firstName / *Ruby は wire では結合された `name` / `nameRuby` で送る
// - birthday は Date | null を YYYY-MM-DD | null に
// - 住所系 (optionalKeys) は form 上で空文字でも wire では null
// - password は未入力 (undefined / 空文字) なら body から削除 (= "更新しない" 意図)
//
// useMe().update() 経由でしか使われないが、wire payload の回帰検知用に分離。
export interface MeUpdateBody {
  name: string
  nameRuby: string
  sex: string | null
  birthday: string | null
  postalCode: string | null
  prefectures: string | null
  municipalities: string | null
  street: string | null
  address: string | null
  building: string | null
  municipalitiesRuby: string | null
  streetRuby: string | null
  addressRuby: string | null
  buildingRuby: string | null
  mailAddress: string
  phoneNumber: string
  password?: string
}

const optionalKeys: (keyof MeUpdateBody)[] = [
  'postalCode',
  'prefectures',
  'municipalities',
  'street',
  'address',
  'building',
  'municipalitiesRuby',
  'streetRuby',
  'addressRuby',
  'buildingRuby',
]

const nullNotAllowedKeys: (keyof MeUpdateBody)[] = ['password']

export const buildMeUpdateBody = (form: EditForm): MeUpdateBody => {
  const body: MeUpdateBody = {
    name: `${form.lastName} ${form.firstName}`,
    nameRuby: `${form.lastNameRuby} ${form.firstNameRuby}`,
    sex: form.sex ?? null,
    birthday: form.birthday ? dayjs(form.birthday).format('YYYY-MM-DD') : null,
    postalCode: form.postalCode,
    prefectures: form.prefectures ?? null,
    municipalities: form.municipalities ?? null,
    street: form.street ?? null,
    address: form.address ?? null,
    building: form.building ?? null,
    municipalitiesRuby: form.municipalitiesRuby,
    streetRuby: form.streetRuby,
    addressRuby: form.addressRuby,
    buildingRuby: form.buildingRuby,
    mailAddress: form.mailAddress,
    phoneNumber: form.phoneNumber,
  }

  // 空文字は API 上では null
  optionalKeys.forEach((key) => {
    if (body[key] === '') (body[key] as string | null) = null
  })

  // 未入力 (undefined / 空文字) は body から削除 (更新しない意図)
  nullNotAllowedKeys.forEach((key) => {
    if (!body[key]) delete body[key]
  })

  return body
}
